

import * as server from "@/utils/http"
// 列表
export const _getUserList = params => server.getByStreetCode("/sysUser/selectPages",params);

export const _roleUserByPages = params => server.getByStreetCode("/sysUser/roleUserByPages",params);

// 根据ID获取用户
export const _getUserById = params => server.getByStreetCode("/sysUser/queryUserById?",params);

// 编辑/创建用户
export const _editUser = params => server.postByStreetCode(params.id ? "/sysUser/update" : "/sysUser/save",params);

// 删除
export const _delUser = params => server.getByStreetCode("/sysUser/delete?",params);
